import { executeRequest, Request, Response } from '@jfs/network'
import { getAPIURL, getPaymentHeader } from '../config'
const responseParser = (response: Response) => {
  const { data } = response
  return data
}

const payLaterPreProcess = (paymentDetails: any, deviceInfo: any) => {
  var deviceData = JSON.stringify(deviceInfo)
  const publicUrl = getAPIURL('preProcess')
  console.log('publicUrl: ', publicUrl)
  const request: Request<{}> = {
    apiPath: publicUrl,
    method: 'POST',
    body: paymentDetails,
    headers: {
      ...getPaymentHeader(),
      'x-device-info': deviceData,
    },
  }
  return executeRequest(request)
    .then((data) => {
      console.log('data: ', data)
      return responseParser(data)
    })
    .catch((error) => {
      console.log('error: ', error)
      throw error
    })
}

export { payLaterPreProcess }
